import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    base_url: '',
    empresa: {
      agendamentos: []
    },
    url_site: ''
  },

  mutations: {
    setEmpresa: (state, data) => {
      state.empresa = data;
      state.base_url = data.server + data.token + '/';
    }
  },

  actions: {
  },

  modules: {
  }
})
